import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshfest-2022';

export default function Example() {
  return (
    <>
      <Head>
        <title>PoshFest 2022: Everything You Need to Know</title>
        <meta
          name='description'
          content='Touted as the ultimate Poshmark experience, PoshFest is happening again soon. How to join PoshFest 2022? Read up and decide if it’s worth a go or not.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshfest-2022' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshfest-2022' />
        <meta property='og:title' content='PoshFest 2022: Everything You Need to Know' />
        <meta
          property='og:description'
          content='Touted as the ultimate Poshmark experience, PoshFest is happening again soon. How to join PoshFest 2022? Read up and decide if it’s worth a go or not.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-08-31T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-08-31T00:00:00-00:00' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
